import {useCallback, useEffect, useRef, useState} from 'react';
import api from '../services/api';
const EMPTY={counts:{1:0,2:0,3:0},notices:[]};
export default function useConfirmationNotices(enabled=true){
 const [data,setData]=useState(EMPTY);
 const [error,setError]=useState('');
 const controller=useRef(null),active=useRef(false);
 const refresh=useCallback(async()=>{
  if(!active.current)return;
  controller.current?.abort();const request=new AbortController();controller.current=request;
  try{
   const response=await api.get('/api/consultation-invitations/confirmations',{signal:request.signal});
   if(!active.current || request.signal.aborted)return;
   setData({counts:response.data.counts || EMPTY.counts,notices:Array.isArray(response.data.notices)?response.data.notices:[]});setError('');
  }catch(err){if(active.current && !request.signal.aborted)setError('Bestätigungshinweise konnten nicht geladen werden. Bitte erneut versuchen.');}
 },[]);
 useEffect(()=>{
  active.current=enabled;if(!enabled){setData(EMPTY);return undefined;}
  const visible=()=>{if(document.visibilityState==='visible')void refresh();};
  void refresh();const timer=setInterval(visible,15000);
  window.addEventListener('focus',visible);window.addEventListener('consultations-changed',visible);document.addEventListener('visibilitychange',visible);
  return()=>{active.current=false;controller.current?.abort();clearInterval(timer);window.removeEventListener('focus',visible);window.removeEventListener('consultations-changed',visible);document.removeEventListener('visibilitychange',visible);};
 },[enabled,refresh]);
 const markSeen=useCallback(async id=>{
  await api.post(`/api/consultation-invitations/confirmations/${id}/seen`);
  await refresh();window.dispatchEvent(new Event('consultations-changed'));
 },[refresh]);
 return {...(enabled?data:EMPTY),error,refresh,markSeen};
}
